import { render, staticRenderFns } from "./BasicFallback.vue?vue&type=template&id=5aaa152e&scoped=true&"
import script from "./BasicFallback.vue?vue&type=script&lang=js&"
export * from "./BasicFallback.vue?vue&type=script&lang=js&"
import style0 from "./BasicFallback.vue?vue&type=style&index=0&id=5aaa152e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa152e",
  null
  
)

export default component.exports